export function minutesToMilliseconds(minutes: number): number {
  return minutes * 60 * 1000;
}

export function millisecondsToMinutes(milliseconds: number): number {
  return milliseconds / 1000 / 60;
}
